__turbopack_context__.v({
  "content": "modal-module__FNUelW__content",
  "mediaWrapper": "modal-module__FNUelW__mediaWrapper",
});
